import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=560f8521&"
import script from "./AlertInfo.vue?vue&type=script&lang=js&"
export * from "./AlertInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports